import color from './color'

// REMOVEME: Remove the neon sub-theme and merge with dark once we go live with the 2.0 branding
export default { color }
